import { PropertySearch } from '__generated__/api';
import { DefaultRequestFields } from 'models';

export const getDefaultRequestFields = (
  searchCriteria: PropertySearch.SearchCriteria,
  region: PropertySearch.Region
): DefaultRequestFields | null => {
  let queryObj = {
    startDate: getDateStringFromDateRange(searchCriteria.dateRange.checkInDate),
    endDate: getDateStringFromDateRange(searchCriteria.dateRange.checkOutDate),
    regionId: region.id
  };

  if (searchCriteria.searchIntent) {
    queryObj = {
      ...queryObj,
      ...searchCriteria.searchIntent
    };
  }

  return queryObj;
};

/**
 * Javascript Date objects require a month index which is why we need minus 1
 * TODO: Add date string logic to the BEX API SDK
 */
const getDateStringFromDateRange = (dateRange: PropertySearch.CheckInDate | PropertySearch.CheckOutDate): string =>
  new Date(Date.UTC(dateRange.year, dateRange.month - 1, dateRange.day)).toISOString().split('T')[0];
